export default __webpack_public_path__ + "static/logo-transparent-8993f6af86a56247c90972523173887b.svg";